/** One feedback item. Anyone not on it gets the same "not found" as a wrong number. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { Callout } from "@/components/ui/callout";
import { useAuth } from "@/features/auth/store";
import { FeedbackDetailPage } from "@/features/feedback/components/feedback-detail-page";
import { errMsg, useFeedback } from "@/features/feedback/hooks";

export const Route = createFileRoute("/_app/feedback/$id")({
  beforeLoad: () => {
    const { me, can } = useAuth.getState();
    if (!me?.features?.feedback || !can("feedback.view"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const q = useFeedback(Number(id));
  if (q.isPending) return <FormPageSkeleton />;
  if (q.isError)
    return (
      <Callout tone="danger" title="Could not open this feedback">
        {errMsg(q.error)}
      </Callout>
    );
  return <FeedbackDetailPage key={q.data.id} item={q.data} />;
}
